import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-toggle-button', 
  templateUrl: './toggle-button.component.html',
  styleUrls: ['./toggle-button.component.scss']
})
export class ToggleButtonComponent {

  @Input() template: any;

  @Output() toggleChange = new EventEmitter<any>(); 


  onToggleChange() {
    this.toggleChange.emit(this.template);
  }
  
}
